import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger)

const Scroll = {
  media: null,
  scroller: null,
  cleanupPageScroll: null,

  init() {
    if (this.media || document.body.classList.contains('wp-admin') || document.querySelector('.editor-styles-wrapper')) return

    this.cleanupPageScroll = this.setupPageScroll()
    this.media = gsap.matchMedia()
    this.media.add('(prefers-reduced-motion: no-preference)', () => {
      const scroller = new Lenis({
        lerp: 0.1,
        smoothWheel: true,
        syncTouch: false,
        autoRaf: false
      })
      this.scroller = scroller

      // Lenis expects milliseconds; GSAP's shared ticker supplies seconds.
      const tick = time => scroller.raf(time * 1000)
      const resize = () => scroller.resize()

      scroller.on('scroll', ScrollTrigger.update)
      gsap.ticker.lagSmoothing(0)
      gsap.ticker.add(tick)
      ScrollTrigger.addEventListener('refresh', resize)
      ScrollTrigger.refresh()

      return () => {
        gsap.ticker.remove(tick)
        ScrollTrigger.removeEventListener('refresh', resize)
        scroller.off('scroll', ScrollTrigger.update)
        scroller.destroy()
        this.scroller = null
      }
    })
  },

  setupPageScroll() {
    const previousRestoration = window.history.scrollRestoration
    const reset = () => {
      let target = 0
      if (window.location.hash) {
        let anchor
        try {
          anchor = decodeURIComponent(window.location.hash.slice(1))
        } catch {
          return
        }
        target = document.getElementById(anchor) || document.getElementsByName(anchor)[0]
        if (!target) return
      }

      ScrollTrigger.clearScrollMemory('manual')

      if (this.scroller) {
        this.scroller.resize()
        this.scroller.scrollTo(target, { immediate: true, force: true })
      } else if (target) {
        target.scrollIntoView({ behavior: 'instant', block: 'start' })
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      }
      ScrollTrigger.update()
    }

    reset()
    // Also reset restored pages, including back/forward cache navigation.
    window.addEventListener('pageshow', reset)

    return () => {
      window.removeEventListener('pageshow', reset)
      ScrollTrigger.clearScrollMemory(previousRestoration)
    }
  },

  destroy() {
    this.media?.revert()
    this.media = null
    this.cleanupPageScroll?.()
    this.cleanupPageScroll = null
  }
}

export default Scroll
